<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourInternal from "../DesignerQuestionDoorColourInternal.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourInternal
        ],
        mounted() {
            window.emitter.on('door-external-colour-updated', (new_colour) => {
                this.localTarget = new_colour;
            });
        },
        onUnmounted() {
            window.emitter.off('door-external-colour-updated');
        },
    }
</script>
